export default __webpack_public_path__ + "static/media/linkedin-icon.d4971a69.svg";